import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=2c6e46b3&"
import script from "./DadosGerais.vue?vue&type=script&lang=js&"
export * from "./DadosGerais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports